import * as types from '@store/types'
import axios from 'axios'

const state = {
  canGetNewNotifications: true,
  newNotification: false,
  notifications: []
}

const getters = {
  [types.NOTIFICATIONS]: ({ notifications }) => notifications,
  [types.NEW_NOTIFICATIONS]: ({ newNotification }) => newNotification
}

const mutations = {
  [types.NOTIFICATIONS]: (state, payload) => {
    state.notifications = payload
  },
  [types.CAN_GET_NEW_NOTIFICATIONS]: (state, payload) => {
    state.canGetNewNotifications = payload
  },
  [types.NEW_NOTIFICATIONS]: (state, payload) => {
    state.newNotification = payload
  }
}

const actions = {
  [types.GET_NOTIFICATIONS]: async ({ state, commit }) => {
    if (state.canGetNewNotifications) {
      try {
        const response = await axios.get('notification')
        commit(types.NOTIFICATIONS, response.data.data)
        commit(types.CAN_GET_NEW_NOTIFICATIONS, false)
        commit(types.NEW_NOTIFICATIONS, false)
      } catch (error) {
        return error
      }
    }
  },

  [types.CHECK_NOTIFICATIONS]: async ({ commit }) => {
    try {
      const response = await axios.get('notification/check')
      if (response.data.data) commit(types.CAN_GET_NEW_NOTIFICATIONS, true)
      commit(types.NEW_NOTIFICATIONS, response.data.data)
    } catch (error) {
      return error
    }
  },

  [types.MARK_NOTIFICATION_AS_READ]: async ({ commit, state }, payload) => {
    try {
      await axios.post(`notification/${payload}`)
      let updatedNotifications = JSON.parse(JSON.stringify(state.notifications))
      updatedNotifications = updatedNotifications.map(notification => {
        if (notification.id === payload) return { ...notification, read: true }
        else return notification
      })
      commit(types.NOTIFICATIONS, updatedNotifications)
    } catch (error) {
      return error
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js